import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { FavoriteCardTypeEnum, UserFavoriteTracker } from './user-favorite-data.model';
import { UpaService, UpaTarget } from 'projects/common/services/upa.service';
import { MediaPictureService } from 'projects/common/services/media-picture.service';

@Injectable({
  providedIn: 'root'
})
export class FavoriteSocialService {
  private SOCIAL_ENDPOINT = '/social-favs';
  private KEY_ALERTS_HISTORY: string = 'alerts-saved-history';


  constructor (@Inject(PLATFORM_ID) private platformId: string,
     private httpClient: HttpClient,
     private upaService: UpaService,
     private mediaPictureService: MediaPictureService) {}

  alertsWasClicked(favId): boolean {
    let alertsHistory: any = null;

    if (sessionStorage.getItem(this.KEY_ALERTS_HISTORY)) {
        alertsHistory = JSON.parse(sessionStorage.getItem(this.KEY_ALERTS_HISTORY)!);
    }

    if (!alertsHistory) {
        return false;
    }

    return alertsHistory[favId];
}

  changeAlertClicked(favId: string): void {
      let alertsHistory: any = null;

      if (sessionStorage.getItem(this.KEY_ALERTS_HISTORY)) {
          alertsHistory = JSON.parse(sessionStorage.getItem(this.KEY_ALERTS_HISTORY)!);
      }

      if (!alertsHistory) {
          alertsHistory = {};
      }

      alertsHistory[favId] = true;

      sessionStorage.setItem(this.KEY_ALERTS_HISTORY, JSON.stringify(alertsHistory));
  }

  sendTracker(moduleId: string, uniqueId: string, moduleIndex: number, label: string, trackerType: UserFavoriteTracker, target: UpaTarget): void {
    this.upaService.trackClickTopic({
      label: `${label}-${trackerType}`,
      moduleId: moduleId,
      moduleIndex: moduleIndex,
      uniqueId: uniqueId,
      target: target
    });
  }

  getFavImgSrcUrl(mediaKey: string, cardType: string){
    const imgSize = cardType === FavoriteCardTypeEnum.REDUCED ? '320x135' :'320x200';
    return this.mediaPictureService.getSrcset(mediaKey, imgSize);
  }
}